// ============================================================================
// condicionFiscal.js — Helpers para interpretar la condición fiscal (IVA) de
// una empresa, cliente o proveedor a partir de texto libre.
// ----------------------------------------------------------------------------
// El sistema guarda la condición fiscal como texto en varios lugares
// (billing_entities.fiscal_configuration, billing_entities.tax_condition,
// organizations.tax_condition, clients/proveedores.tax_condition). Estos
// helpers normalizan ese texto para decidir el tratamiento de IVA sin depender
// de la grafía exacta.
//
// Regla de negocio clave (Compras):
//  - Responsable Inscripto (RI): el IVA de compra es CRÉDITO FISCAL, va al
//    Libro IVA y NO forma parte del costo del producto.
//  - Monotributo / Exento / cualquier otro caso: el IVA de compra es un costo
//    más (no se computa como crédito fiscal). Para estos casos el módulo de
//    compras mantiene su comportamiento histórico sin cambios.
// ============================================================================

export const normCond = (v) => String(v || '').trim().toLowerCase();

// Responsable Inscripto (incluye "IVA Responsable Inscripto").
export const esRI = (cond) => {
  const c = normCond(cond);
  return c.includes('responsable') && c.includes('inscrip');
};

export const esMonotributo = (cond) => normCond(cond).includes('monotrib');

export const esExento = (cond) => normCond(cond).includes('exento');

export const esConsumidorFinal = (cond) => {
  const c = normCond(cond);
  return c.includes('consumidor') && c.includes('final');
};

// Resuelve la condición fiscal efectiva de la empresa a partir de las fuentes
// disponibles, en orden de preferencia. Devuelve el primer texto no vacío.
export const resolverCondicionEmpresa = ({ billingEntity = null, organization = null } = {}) =>
  billingEntity?.fiscal_configuration
  || billingEntity?.tax_condition
  || organization?.tax_condition
  || organization?.fiscal_configuration
  || '';

// ¿La empresa computa crédito fiscal de IVA en sus compras? Solo los RI.
export const empresaComputaCreditoFiscal = (sources) => esRI(resolverCondicionEmpresa(sources));
